import { useEffect, useRef, useState } from "react";
import useClickOutside from "../../../Hooks/useClickOutside";
import GeneralService from "../../../Services/Dashboard/GeneralService";
import InvoiceInput from "../Invoice/InvoiceInput";

const States = ({ states, placeholder, ...props }) => {
  useEffect(() => {}, []);

  return (
    <>
      <CustomSelect
        className="mt-2 mb-5 w-full"
        states={states}
        {...props}
        placeholder={placeholder}
      />
    </>
  );
};

const CustomSelect = ({ states, placeholder, defaultValue, ...props }) => {
  const [search, setSearch] = useState("");
  const [field, setField] = useState(null);
  const [data, setData] = useState([]);

  const details = useRef();
  const check = useRef();

  const loadOptions = (inputValue) => {
    GeneralService.countries(inputValue).then((response) => {
      let data = response?.data?.data?.result
        .filter((v) => v.name.toLowerCase() === "nigeria")[0]
        .states.filter((v) => {
          return v.name.toLowerCase().includes(inputValue.toLowerCase());
        })
        .sort((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      setData(data ?? []);
    });
  };

  useClickOutside(details, () => {
    details.current.removeAttribute("open");
  });

  useEffect(() => {
    // if (search !== "") {
    loadOptions(search);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div>
      <label
        className="mb-1 w-full text-base capitalize text-gray-700"
        style={{ fontWeight: 700, fontSize: "18px" }}
      >
        {props.label}
      </label>
      <details
        className="relative text-[12px] font-[700] leading-[18px]"
        ref={details}
      >
        <summary className="form-input w-full list-none border bg-transparent px-4 py-5 text-sm font-semibold tracking-wide text-gray-800 placeholder:capitalize placeholder:text-gray-400 focus:border-purple-800 focus:outline-none">
          {field ?? placeholder ?? "Search for state"}
        </summary>
        <ul className="absolute z-40 mb-2 max-h-40 w-full overflow-y-scroll bg-white shadow-lg">
          <li className="px-6">
            <InvoiceInput
              normalize={true}
              placeholder="Search for state"
              type="text"
              onChange={(e) => {
                setSearch(e.target.value);
                setField(null);
                check.current.checked = true;
              }}
              value={search}
            />
            <input
              type="radio"
              ref={check}
              {...props}
              className="hidden"
              value=""
            />
          </li>
          {data.map((v, i) => (
            <li key={i} className="w-full">
              <label
                onClick={() => {
                  setField(v.name);
                  details.current.removeAttribute("open");
                }}
              >
                <input
                  type="radio"
                  {...props}
                  className="peer hidden"
                  value={v.name}
                  defaultChecked={v.name === defaultValue?.toLowerCase()}
                  onChange={() => {}}
                />
                <span className="inline-block w-full cursor-pointer px-6 py-2 text-black hover:bg-blue-500 hover:text-white peer-checked:bg-blue-700 peer-checked:text-white">
                  {v.emoji} {v.name}
                </span>
              </label>
            </li>
          ))}
          {data.length <= 0 && (
            <li className="inline-block cursor-pointer px-6 py-2 text-black">
              No Data Available yet
            </li>
          )}
        </ul>
      </details>
    </div>
  );
};

export default States;
